module.exports = __webpack_public_path__ + "img/facility.0aeffeab.svg";